export function enumToDisplayNames(enumArray, filterFunction = () => true) {
    return Object.values(enumArray)
        .reduce((acc, cur) => {
            if (cur.displayName && filterFunction(cur)) {
                acc[cur.value] = cur.displayName;
            }
            return acc;
        }, {});
}

export function enumValueToDisplayName(enumArray, enumValue) {
    return enumArray[enumValue]?.displayName || null;
}

export function enumNameToValue(enumArray, enumName) {
    return Object.values(enumArray).find((option) => option?.name === enumName)?.value;
}

export function enumValueToName(enumArray, enumValue) {
    return enumArray[enumValue]?.name;
}

function createTuple(options, excludedOptions = []) {
    return Object.entries(options).reduce((acc, [key, value]) => {
        if (excludedOptions.includes(value)) {
            return acc;
        }
        if (acc.length > 0) {
            acc[0] = `${acc[0]} + ${key}`;
            acc[1] = acc[1] | value;
        }
        else {
            acc[0] = key;
            acc[1] = value;
        }
        return acc;
    }, []);
}

function createCombinedOption(options, excludedOptionsFromCombined) {
    const tuple = createTuple(options, excludedOptionsFromCombined);

    return Object.fromEntries([tuple]);
}

export function enumToSelectOptions(enumArray, filterFunction = () => true, sortFunction = (s) => s, includeCombinedOption = false, excludedOptionsFromCombined) {
    let combinedOption = {};
    const options = Object.values(enumArray)
        .filter(c => !!c.displayName)
        .sort(sortFunction)
        .reduce((acc, cur) => {
            if (filterFunction(cur)) {
                acc[cur.displayName] = cur.value;
            }
            return acc;
        }, {});

    if (includeCombinedOption) {
        combinedOption = createCombinedOption(options, excludedOptionsFromCombined);
    }

    return {
        ...options,
        ...combinedOption,
    };
}

export function createDefaultSelectOption(options, defaultOptionValue, resouce = 'Default') {
    return `${resouce} (${Object.keys(options).find(key => options[key] === defaultOptionValue)})`;
}

export function excludeEnumValues(object, keys) {
    const filteredEntries = Object.entries(object)
        .filter(([key, value]) => !keys.includes(parseInt(key)) && !keys.includes(value));

    return Object.fromEntries(filteredEntries);
}

export function hasFlag(enumValue, flag) {
    if (enumValue === null || enumValue === undefined) {
        return false;
    }
    return (enumValue & flag) === flag;
}

export function filterEnumByKey(object, keys) {
    const keysAsString = keys.map((k) => k.toString());
    return Object.keys(object).reduce((acc, cur) => {
        if (keysAsString.includes(cur)) {
            acc.push(object[cur]);
        }
        return acc;
    }, []);
}

export function displayNameFromResources(resource, enumValue) {
    if (resource[enumValue.displayName]) {
        return resource[enumValue.displayName];
    }
    throw new Error(`Resource ${ enumValue.displayName } not found`);
}

export function mapEnumDisplayNameFromResource(resource, options) {
    return Object.entries(options)
        .reduce((acc, [key, value]) => {
            if (value.displayName) {
                acc[key] = { ...value, displayName: displayNameFromResources(resource, value) };
            }
            return acc;
        }, {});
}

export function mapEnumFromResourceToOptions(resource, options, filterFunction = () => true, sortFunction = (s) => s, includeCombinedOption = false, excludedOptionsFromCombined ) {
    const translatedOptions = mapEnumDisplayNameFromResource(resource, options);
    return enumToSelectOptions(translatedOptions, filterFunction, sortFunction, includeCombinedOption, excludedOptionsFromCombined);
}
